import React from "react";
import {useMediaTypeQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import {GraphQlSelect} from "./GraphQlSelect";

export const MediaTypeSelect = (props) => {
    const query = useMediaTypeQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}